import { Link } from 'react-router-dom';
import CapabilitiesSection from '../components/CapabilitiesSection';
import CtaBand from '../components/CtaBand';
import CustomSoftwareSection from '../components/CustomSoftwareSection';
import PageHero from '../components/PageHero';
import ProductsPortfolioSection from '../components/ProductsPortfolioSection';
import SectionHeader from '../components/SectionHeader';
import Seo from '../components/Seo';
import { EGRAHMANTREE_URL, PRODUCTS, SITE, VALUES } from '../config/site';

export default function About() {
  return (
    <>
      <Seo
        title="About"
        description={`About ${SITE.legalName} — ${SITE.positioning}. Products: eGrahmantree, SutraMQ, SutraACS, MGOpen NMS.`}
        path="/about"
      />

      <PageHero
        label="About"
        title="A product company with enterprise discipline"
        tagline={SITE.domain}
        lead={
          <>
            {SITE.legalName} is headquartered in Jaipur, India. We operate {PRODUCTS.length} software
            lines — from live consumer services at{' '}
            <a href={EGRAHMANTREE_URL} target="_blank" rel="noopener noreferrer">
              egrahmantree.com
            </a>{' '}
            to MQTT, TR-069 ACS, and network management platforms for operators and enterprises.
          </>
        }
      />

      <ProductsPortfolioSection creative compact />

      <CapabilitiesSection />

      <section className="section section--band">
        <div className="container about-grid">
          <div>
            <SectionHeader creative light label="Who we are" title="Built in India, engineered for scale" />
            <p className="about-copy">
              We are a product company first — not a generic dev shop. Every platform we ship is designed
              for production workloads, with AI and cloud applied where they create measurable value for
              operators and customers.
            </p>
            <div className="values-grid">
              {VALUES.map((v, i) => (
                <div key={v.title} className="value-item">
                  <span className="value-item__num">0{i + 1}</span>
                  <div>
                    <h4>{v.title}</h4>
                    <p>{v.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="card card--glass">
            <SectionHeader creative light label="At a glance" title="What we deliver" />
            <ul className="expertise-list">
              <li>Product lines: SutraMQ, SutraACS, MGOpen NMS, eGrahmantree</li>
              <li>AI, GenAI, and agentic automation for production systems</li>
              <li>Multi-cloud engineering on AWS, Google Cloud, and Azure</li>
              <li>Full-stack web, mobile, Rust, and Java/Spring engineering</li>
            </ul>
            <p style={{ marginTop: '1.5rem', marginBottom: 0 }}>
              <Link to="/demo">Request a demo →</Link>
            </p>
          </div>
        </div>
      </section>

      <CustomSoftwareSection creative />

      <CtaBand
        creative
        title="Partner with our team"
        description={`Work with ${SITE.shortName} on your next platform — from architecture to production operations.`}
        primaryLabel="Request a demo"
        primaryHref="/demo"
        primaryExternal={false}
        secondaryLabel="Contact us"
        secondaryTo="/contact"
      />
    </>
  );
}
